__turbopack_context__.v({
  "buttons": "style-module-scss-module__JVp7la__buttons",
  "checkbox-container": "style-module-scss-module__JVp7la__checkbox-container",
  "component": "style-module-scss-module__JVp7la__component",
  "exp-theme": "style-module-scss-module__JVp7la__exp-theme",
  "header": "style-module-scss-module__JVp7la__header",
});
